import * as React from 'react';

import { Button } from '../Button';
import { Icon } from '../Icon';
import { Stack } from '../Stack';

interface TableSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const TableSearch: React.FC<TableSearchProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <Stack
      className="border-b border-border-primary"
      direction="horizontal"
      align="center"
    >
      <Icon
        name="Search"
        size="xl"
        className="size-10! p-2.5 text-text-secondary"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border-none bg-transparent focus:ring-0 focus:outline-hidden"
        placeholder={placeholder ?? 'Search...'}
      />

      {value && (
        <Button
          onClick={() => onChange('')}
          variant="ghost"
          className="m-0 hover:bg-text-secondary/5"
          aria-label="Clear search"
        >
          <Icon name="X" size="lg" className="text-text-secondary" />
        </Button>
      )}
    </Stack>
  );
};
